<template>
  <div id="map" ref="map" class="map" />
</template>

<script>
export default {
  name: 'GoogleMapViewport',
  props: {
    mapsApiContext: { type: Object, default: null },
    locations: { type: Array, default: Array },
    place: { type: Object, default: Object },
  },
  data() {
    return {
      markers: [],
      mapInstance: null,
      infoWindow: null,
      markerIcons: {
        office: 'http://maps.google.com/intl/en_us/mapfiles/ms/micons/blue-dot.png',
        cement: 'http://maps.google.com/intl/en_us/mapfiles/ms/micons/red-dot.png',
        asphalt: 'http://maps.google.com/intl/en_us/mapfiles/ms/micons/purple-dot.png',
        'ready-mix-concrete': 'http://maps.google.com/intl/en_us/mapfiles/ms/micons/ltblue-dot.png',
        construction: 'http://maps.google.com/intl/en_us/mapfiles/ms/micons/yellow-dot.png',
        'sustainable-products':
          'http://maps.google.com/intl/en_us/mapfiles/ms/micons/green-dot.png',
        aggregates: 'http://maps.google.com/intl/en_us/mapfiles/ms/micons/orange-dot.png',
        none: 'http://maps.google.com/intl/en_us/mapfiles/ms/micons/pink-dot.png',
      },
    }
  },
  watch: {
    mapsApiContext: {
      handler() {
        this.$nextTick(this.generateMap)
      },
      immediate: true,
    },
    locations() {
      if (!this.mapsApiContext) return
      this.generateMarkers(this.mapsApiContext)
    },
    place(place) {
      if (!place || !this.mapInstance) return
      this.mapInstance.panTo({ lat: place.lat(), lng: place.lng() })
      this.mapInstance.setZoom(10)
    },
  },
  mounted() {
    this.$nextTick(this.generateMap)
  },
  methods: {
    generateMap() {
      if (!this.mapsApiContext) return
      const maps = this.mapsApiContext
      this.mapInstance = new maps.Map(this.$refs.map, {
        center: { lat: 46.814, lng: -71.243 },
        disableDefaultUI: true,
        zoom: 4,
        minZoom: 2,
        maxZoom: 17,
      })

      this.generateMarkers(maps)
    },
    generateMarkers(maps) {
      this.markers.forEach((marker) => {
        if (marker.map) marker.map = null
      })

      this.markers = this.locations.map((location) => {
        const marker = new maps.marker.AdvancedMarkerElement({
          map: this.mapInstance,
          position: new maps.LatLng(location.address.latitude, location.address.longitude),
          title: location.name,
        })
        marker.addListener('click', () => {
          const latLng = new maps.LatLng(location.address.latitude, location.address.longitude)
          this.generateInfoWindow(maps, location, latLng)
        })
        return marker
      })
    },
    generateInfoWindow(maps, { name, address, phone, lat, lng }, latLng) {
      if (this.infoWindow) this.infoWindow.map = null

      this.infoWindow = new maps.InfoWindow({
        content: `
          <div class="map__info-window">
            <div style="font-size:1.15rem">${name}</div>
            <address>${address.street}</address>
            <div>${address.city}, ${address.region || ''} ${address.postcode}</div>
            <div>${phone || ''}</div>
            <div style="color: blue" onclick="window.open('https://www.google.com/maps/dir/?api=1&destination=${address.latitude}, ${address.longitude}', '_blank')">
                Get directions
            </div>
          </div>
        `,
      })

      this.infoWindow.position = latLng
      this.infoWindow.map = this.mapInstance
    },
  },
}
</script>
